<template>
  <div class="selectBox" @click.stop>
    <div class="selectText" @click="editShowList">
      <a-input v-model="text" :class="{inputFoucs: showList}" class="showList" disabled placeholder="请选择" />
      <span v-show="closeShow" class="closeStyle" @click.stop="removeData">×</span>
    </div>
    <div :class="showList ? 'selectList activeList' : 'selectList'">
      <div class="selectSearch">
        <a-input-search
          ref="searchValue"
          v-model="searchValue"
          placeholder="请输入关键字搜索"
          allow-clear
          @change="onSearchChange"
          @search="onSearch"
        />
      </div>
      <a-checkbox
        clang="selectAll"
        :indeterminate="indeterminate"
        :checked="checkAll"
        @change="onCheckAllChange"
      >全选</a-checkbox>
      <div v-show="list.length > 0" class="dataList">
        <a-checkbox-group v-model="checkedList" :options="list" @change="onChange"></a-checkbox-group>
      </div>
      <div v-show="list.length <= 0" class="nullData">暂无数据</div>
    </div>
  </div>
</template>

<script>
import { OrderProgressTab } from '../../constant';

export default {
  props: {
    // ["list", "currentTab"]
    list: {
      type: Array,
      default: () => ([]),
    },
    currentTab: {
      type: String,
      default: '',
    },
    resetData: {
      type: String
    }
  },
  data() {
    return {
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      plainOptions: this.list,
      showList: false,
      text: "",
      closeShow: false,
      searchValue: "",
    };
  },
  computed: {},
  watch: {
    currentTab: {
      async handler(value) {
        await this.reseData(value);
      },
      immediate: true,
    },
    showList(val) {
      if (val) {
        this.$refs.searchValue.focus()
      }
    },
  },
  created() {},
  mounted() {
    window.addEventListener("click", () => {
      this.onshowList();
    });
  },
  methods: {
    onChange(checkedList) {
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.$props.list.length;
      this.checkAll = checkedList.length === this.$props.list.length;
      if (this.checkedList.length > 0) this.closeShow = true;
      else this.closeShow = false;
      if (checkedList.length > 1) {
        this.text = `已选中${checkedList.length}项`;
      } else if (checkedList.length === 1) {
        this.list.forEach((e) => {
          if (e.value === checkedList[0]) {
            this.text = e.label;
          }
        });
      } else {
        this.text = "";
      }
      this.$emit("checkedList", checkedList);
    },
    onCheckAllChange(e) {
      const data = [];
      if (e.target.checked) {
        this.$props.list.forEach(l => {
          data.push(l.value);
        });
      }

      Object.assign(this, {
        checkedList: data,
        indeterminate: false,
        checkAll: e.target.checked,
      });
      if (e.target.checked) {
        this.text = `已选中${this.checkedList.length}项`;
        this.closeShow = true;
      } else {
        this.text = "";
        this.closeShow = false;
      }
      this.$emit("checkedList", this.checkedList);
    },
    onSearch(value) {
      this.$emit("onSearch", value);
    },
    onSearchChange() {
      this.$emit("onSearch", this.searchValue);
    },
    onshowList() {
      this.showList = false;
      this.searchValue = "";
    },
    editShowList() {
      this.showList = !this.showList;
      if(this.showList) {
        this.onSearchChange();
        
      }
    },
    removeData() {
      this.checkedList = [];
      this.text = "";
      this.checkAll = false;
      this.indeterminate = false
      // 需重新请求列表接口
      this.$emit("checkedList", []);
    },
    async reseData(value) {
      await this.onSearchChange();
      let checkAll = true;
      const arr = [];
      this.list.forEach((e) => {
        if (value === OrderProgressTab.ALL) {
          if (!e.notShow) {
            arr.push(e.value);
          } else {
            checkAll = false;
          }
        } else {
          arr.push(e.value);
        }
      });
      this.checkAll = checkAll;
      this.indeterminate = !checkAll;
      this.checkedList = arr;
      this.closeShow = true;
      if (value === "DOING" || value === "ALL") {
        this.text = `已选中${arr.length}项`;
      } else {
        this.text = this.list[0].label;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.selectBox {
  // width: 187px;
  position: relative;
  .selectText {
    .inputFoucs {
      border-color: #25c48d;
    }
  }
  .selectList {
    position: absolute;
    top: 40px;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 0;
    border: none;
    background-color: #fff;
    transition: all ease 0.3s;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 4px;
    .ant-input-search {
      vertical-align: top;
      margin-top: -1px;
    }
    .selectSearch {
      width: calc(100% + 2px);
      margin-left: -1px;
      /deep/ .ant-input {
        background: #f6f6f6;
        border: none;
      }
      /deep/ .ant-input:focus {
        box-shadow: initial !important;
        border-color: #c9c9c9 !important;
      }
    }
    .dataList {
      // overflow-y: scroll;
      // padding: 0 10px 0 0;
      overflow: auto;
      height: calc(100% - 80px);
      /deep/ .ant-checkbox-group {
        .ant-checkbox-wrapper {
          margin: 0;
          &:hover {
            background: #dff7eb;
          }
        }
      }
    }
    /deep/ .ant-checkbox-group {
      width: 100%;
    }
    /deep/ .ant-checkbox-group-item {
      font-size: 12px;
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 20px;
      box-sizing: border-box;
      &:hover {
        background-color: #f5f5f5;
      }
    }
    .ant-checkbox-wrapper {
      padding: 0 20px;
      box-sizing: border-box;
      background-color: #fff;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      box-shadow: 0 10px 10px 5px rgba(0, 0, 0, 0.3);
    }
    .nullData {
      color: #ccc;
      text-align: center;
    }
  }
  .activeList {
    height: 250px;
    border: 1px solid #d9d9d9;
  }
  .closeStyle {
    width: 14px;
    height: 14px;
    text-align: center;
    line-height: 12px;
    position: absolute;
    right: 10px;
    top: 14px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.25);
    color: #fff;
    font-size: 12px;
    border-radius: 50%;
    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.65);
    }
  }
}
/deep/ .ant-input[disabled] {
  color: #323232 !important;
  background-color: #fff !important;
}
</style>
